export enum ExperienceLevelEnum {
  ZERO = "I just started going to the gym",
  ONE = "I've been going for a while, but infrequently",
  TWO = "I'm at the gym at least 1-3 times per week",
  THREE = "I practically live there",
  FOUR = "I'm a personal trainer",
  FIVE = "I'm a staff member"
}

export enum FitnessGoalEnum {
  ZERO = "Lose Weight",
  ONE = "Gain Muscle",
  TWO = "Increase Flexibility",
  THREE = "Increase Range of Movement",
  FOUR = "Get Stronger",
  FIVE = "Train for an Event",
  SIX = "Cutting Phase",
  SEVEN = "Bulking Phase",
  EIGHT = "Maintenance Phase",
  NINE = "Increase Energy"
}

export enum GenderEnum {
  MALE = 'male',
  FEMALE = 'female'
}



// WEBPACK FOOTER //
// ./src/app/_utils/members-categories-enums.ts